import { render, staticRenderFns } from "./AlertListComponent.vue?vue&type=template&id=13720b07&scoped=true"
import script from "./AlertListComponent.vue?vue&type=script&lang=js"
export * from "./AlertListComponent.vue?vue&type=script&lang=js"
import style0 from "./AlertListComponent.vue?vue&type=style&index=0&id=13720b07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13720b07",
  null
  
)

export default component.exports